// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__Vs51h","content":"ManualTimeModal_content__3v19I"};